import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { formValueSelector, change, submit } from 'redux-form';
import { connect } from 'react-redux';
import { map, get, isEmpty, filter, assign, omit } from 'lodash';
import { CREATE_ITEM_FORM } from '../../constants/formNames';
import { inventoryErrors, priceOptions } from './utils';
import CreateItemForm from './CreateItemForm';
import { injectIntl, intlShape } from 'react-intl';
import { collectVatCopy, addOnTaxTypeOptions } from '../../../../../app-addons/utils';

class CreateItemFormContainer extends Component {
  constructor (props) {
    super(props);

    this.state = {
      addOnImgUrl: '',
      addOnImgId: '',
      submitPhoto: false
    };

    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handlePhotoChange = this.handlePhotoChange.bind(this);
    this.handleRemovePhotoClick = this.handleRemovePhotoClick.bind(this);
    this.changeSubmitPhotoState = this.changeSubmitPhotoState.bind(this);
  }

  componentDidMount () {
    const {
      isEditAddOnModal,
      fromManageAddons,
      initialValues = {},
      spaceId
    } = this.props;
    const { currency = {}, ...restOfValues } = initialValues;
    const propsData = assign({}, {
      space_id: spaceId,
      origin: fromManageAddons ? 'Inventory' : 'Custom Offer'
    }, isEditAddOnModal ?
      {
        currency_symbol: currency.symbol,
        currency_type: currency.code,
        ...restOfValues
      } : {});

    this.setState({
      addOnImgId: get(this.props, 'initialValues.image_ids[0]', '')
    });

    analyticsIntegrations.createItemFormViewed(`${isEditAddOnModal ? 'edit' : 'create'} item form viewed`, omit(propsData, ['group_id', 'taxes', 'fees']));
  }

  handleCategoryChange () {
    this.props.dispatch(change(CREATE_ITEM_FORM, 'subcategory', null));
  }

  handlePhotoChange (photoUrl, photoId) {
    const { isEditAddOnModal, dispatch } = this.props;

    this.setState({
      addOnImgUrl: photoUrl,
      addOnImgId: photoId,
      submitPhoto: true
    }, () => {
      if (isEditAddOnModal) {
        dispatch(submit(CREATE_ITEM_FORM));
      }
    });
  }

  handleRemovePhotoClick () {
    this.setState({
      addOnImgUrl: '',
      addOnImgId: '',
      submitPhoto: true
    }, () => {
      this.props.dispatch(submit(CREATE_ITEM_FORM));
    });
  }

  changeSubmitPhotoState () {
    this.setState({
      submitPhoto: false
    });
  }

  render () {
    const { addOnImgUrl, addOnImgId, submitPhoto } = this.state;
    const categoryOptions = map(this.props.categories, category => {
      return {
        value: category.id,
        label: category.name
      };
    });

    const { fees, intl, env, profile } = this.props;
    const ssoId = get(profile, 'SSOid', '');
    const isVatEnabled = get(env, 'web.is_vat_enabled');

    const feeTypes = get(fees, 'feeTypes', []);

    const federalFee = filter(feeTypes, (feeType) => { return !feeType.is_subregion; });

    const isCanada = 'CA' === get(federalFee, 'country');
    const federalFeeName = isCanada ? 'other' : get(federalFee, '[0].name', 'other');
    const feeTypeNames = isEmpty(feeTypes) ?
      ['sales_tax']
      :
      map(feeTypes, (feeType) => {
        return feeType.name;
      });

    const intlCollectVatCopy = collectVatCopy[federalFeeName];

    const intlAddOnTaxTypes = filter(map([...feeTypeNames, 'other'], (taxTypeName) => {
      const addOnTaxType = get(addOnTaxTypeOptions, taxTypeName, '')
      if (addOnTaxType) {
        return {
          value: taxTypeName,
          label: intl.formatMessage({ ...addOnTaxType })
        };
      }
    }));

    return (
      <CreateItemForm
        {...this.props}
        handleCategoryChange={this.handleCategoryChange}
        handlePhotoChange={this.handlePhotoChange}
        handleRemovePhotoClick={this.handleRemovePhotoClick}
        changeSubmitPhotoState={this.changeSubmitPhotoState}
        categoryOptions={categoryOptions}
        priceOptions={priceOptions}
        addOnImgUrl={addOnImgUrl}
        addOnImgId={addOnImgId}
        submitPhoto={submitPhoto}
        isVatEnabled={isVatEnabled}
        intlCollectVatCopy={intlCollectVatCopy}
        intlAddOnTaxTypes={intlAddOnTaxTypes}
      />
    );
  }
}

CreateItemFormContainer.propTypes = {
  currency: PropTypes.string,
  categories: PropTypes.array,
  subCategoryOptions: PropTypes.array,
  dispatch: PropTypes.func,
  isEditAddOnModal: PropTypes.bool,
  fromManageAddons: PropTypes.bool,
  initialValues: PropTypes.object,
  spaceId: PropTypes.string,
  intl: intlShape
};

const selector = formValueSelector(CREATE_ITEM_FORM);

function mapStateToProps (state, ownProps) {
  const addOnFeeValues = selector(state, 'fees');
  const addOnTaxValues = selector(state, 'taxes');
  const category = selector(state, 'category');
  const subcategories = get(state, `env.addOns.subcategories[${category}]`);
  const categories = get(state, 'env.addOns.categories');
  const nonVatTaxTypes = get(state, 'env.addOns.nonVatTaxTypes');
  const isSubmitting = get(state, 'inventory.isPosting');
  const isFetching = get(state, 'inventory.isFetching');
  const inventoryItem = get(state, 'inventory.item');
  const { auth, add_ons, profile, env, fees } = state;
  const addItemsForm = get(state, 'form.ADD_ITEMS_FORM.values.addOns');
  const isVatEnabled = get(env, 'web.is_vat_enabled');
  const inventoryErrorCode = get(state, 'inventory.error', null);
  const inventoryError = get(inventoryErrors, inventoryErrorCode, null);

  const subcategoryOptions = map(subcategories, subcategory => {
    return {
      value: subcategory.id,
      label: subcategory.name
    };
  });

  const returnObj = {
    addOnFeeValues,
    categories,
    subcategoryOptions,
    isSubmitting,
    isFetching,
    auth,
    add_ons,
    profile,
    addItemsForm,
    env,
    fees,
    addOnTaxValues,
    nonVatTaxTypes,
    inventoryError
  };

  if (ownProps.isEditAddOnModal && !isEmpty(inventoryItem)) {
    const { visible_on_listing, unit_cost, count, ...itemDetails } = inventoryItem;

    const taxes = filter(inventoryItem.additional_charges, { charge_type: 'tax' });
    const fees = filter(inventoryItem.additional_charges, { charge_type: 'fee' });

    // This is how we should filter addons with VAT UI
    const vatTaxes = filter(map(inventoryItem.additional_charges, (charge => {
      if ('fee' !== get(charge, 'charge_type', '')) {
        const other_label = 'tax' === charge.charge_type ? 'other' : null;

        if (other_label) {
          return {
            ...charge,
            other_label: charge.label,
            label: 'other'
          };
        }

        return { ...charge };
      }
    })));

    const taxesToMap = isVatEnabled ? vatTaxes : taxes;

    const taxesArray = map(taxesToMap, tax => {
      if ('%' === tax.charge_unit) {
        return {
          ...tax,
          amount: tax.amount * 100
        };
      }

      return tax;
    });

    const feesArray = map(fees, fee => {
      if ('%' === fee.charge_unit) {
        return {
          ...fee,
          amount: fee.amount * 100
        };
      }

      return {
        ...fee,
        amount: fee.amount.toFixed(2)
      };
    });

    return {
      ...returnObj,
      initialValues: {
        ...itemDetails,
        unit_cost: unit_cost.toFixed(2),
        visible_on_listing: visible_on_listing ? 'true' : 'false',
        taxes: taxesArray,
        fees: feesArray,
        count: count || null
      }
    };
  }

  return returnObj;
}

export default connect(mapStateToProps)(injectIntl(CreateItemFormContainer));
